import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from "axios"
import Home from '../views/Home.vue'
import Register from '../views/Register'
import Login from '../views/Login.vue'
import Test from '../views/Test.vue'
import ShowProduct from '../views/Product/ShowProduct.vue'
import Productdetail from '../views/Product/ProductDetail.vue'
import ArticleList from '../views/Article/ArticleList.vue'
import ArticleContent from '../views/Article/ArticleContent.vue'
import Contact from '../views/Contact'
import Profile from '../views/Account/Profile.vue'
import AdminDashboard from '../views/Dashboard/AdminDashboard.vue'
import Download from '../views/Downloads/Download.vue'
import Copytrade from '../views/Downloads/CopyTrade.vue'
import Carrytrade from '../views/Downloads/AutoRebalance.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home',component: Home, meta: { requiresAuth: true }},
  { path: '/register', name: 'register', component: Register, meta: { Auth: true } },
  { path: '/login', name: 'login', component: Login, meta: { Auth: true } },
  { path: '/test', name: 'test', component: Test, meta: { requiresAuth: true }},
  { path: '/contact', name: 'contact', component: Contact, meta: { requiresAuth: true }},

  //User Product
  { path: '/product', name: 'showproduct', component: ShowProduct, meta: { requiresAuth: true } },
  { path: '/product/:id', name: 'productdetail', component: Productdetail , meta: { requiresAuth: true }},

  //Account
  { path: '/profile', name: 'profile', component: Profile , meta: { requiresAuth: true }},

  //Article
  { path: '/article', name: 'article', component: ArticleList , meta: { requiresAuth: true }},
  { path: '/article/:id', name: 'articlecontent', component: ArticleContent , meta: { requiresAuth: true }},
  

  //Downloads
  { path: '/download', name: 'download', component: Download , meta: { requiresAuth: true }},
  { path: '/download/copytrade', name: 'copytrade', component: Copytrade , meta: { requiresAuth: true }},
  { path: '/download/auto-rebalance', name: 'carrytrade', component: Carrytrade , meta: { requiresAuth: true }},

  //Admin Management
  { path: '/admin', name: 'admin-dashboard', component: AdminDashboard, meta: { requiresAuth: ['admin'] } },
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// ตรวจสอบสิทธิ์การเข้าถึงหน้า
router.beforeEach((to, from, next) => {

  if (to.meta.Auth) {
    axios.get('backend/getUserLogin').then((response) => {
      if(response.data.status == 'S'){
        console.log(response)
        next({ path: '/' })
      }
      else{
        next()
      }
    })
  }

  const requiresAuth = to.meta.requiresAuth;
  if (!requiresAuth) {
    return next()
  }
  axios.get('backend/getUserLogin')
    .then((resp) => { 
      console.log(resp)
      if(resp.data.status == 'S') {
        if (!Array.isArray(requiresAuth)) {
          return next()
        } 
        const User_login = resp.data.user
        if (requiresAuth.indexOf(User_login.role) >= 0) {
          return next()
        } else {
          next({ path: '/' })
        }
        //next()
      } 
      else {
        next({ name: 'login' })
      }
    })
    .catch(() => next({ name: 'login' }));
})




export default router
